import pdfMake from 'pdfmake/build/pdfmake.js';
import getBase64ImageFromURL from '../../../../ClinicEvent/components/PdfReports/GetImage';
import moment from 'moment';


const labReport = async (data) => {

    console.log("COMINGTOLAB", data);

    pdfMake.fonts = {
        OpenSans: {
            normal: 'OpenSans-Regular.ttf',
            bold: 'OpenSans-Bold.ttf',
            italics: 'OpenSans-Italic.ttf',
            bolditalics: 'OpenSans-ExtraBoldItalic.ttf'
        },
        Merriweather: {
            normal: 'Merriweather-Regular.ttf',
            bold: 'Merriweather-Bold.ttf',
            italics: 'Merriweather-Italic.ttf',
            bolditalics: 'Merriweather-ExtraBoldItalic.ttf'
        },
        Roboto: {
            normal: 'Roboto-Regular.ttf',
            bold: 'Roboto-Bold.ttf',
            italics: 'Roboto-Italic.ttf',
            bolditalics: 'Roboto-BoldItalic.ttf'
        }
    };


    const urlLogo = process.env.REACT_APP_PUBLIC_URL + "clinica/" + data.clinic.id_clinica + "/logo/" + sessionStorage.getItem('token')

    const date = moment(new Date()).format('L');

    const tiempo = moment(data.patient.fec_nacimiento, "YYYYMMDD").fromNow();

    const edad = tiempo.substr(5, (tiempo.length - 1))

    const header = {
        margin: [40, 10, 0, 0],
        layout: 'noBorders',
        table: {
            widths: ['*', '*'],
            body: [
                [{
                    image: await getBase64ImageFromURL(urlLogo),
                    fit: [150, 150],
                },
                {text: "Resultados Exámenes " + data.clinic.nombre + "\n" + data.clinic.direccion.direccion + "\n Tel1: " + data.clinic.telefono1 +  " - " + data.clinic.telefono2 +  "\n Fecha: " + date,  style: 'head' }],
            ]
        },
    };

    const foter = {
        margin: [20, 0, 0, 0],
        text: data.clinic.nombre + " " + data.clinic.direccion.direccion + " Tel: " + data.clinic.telefono1 + "\n Impreso por software SAC", style: 'footer',
    };

    const documentDefinition = {
        pageSize: 'LETTER',
        pageOrientation: 'portrait',
        header: header,
        footer: foter,
        info: {
            author: "Josue Hurtado",
        },
        content: [
            {
                margin: [0, 30, 0, 10],
                layout: 'headerLineOnly',
                table: {
                    headerRows: 1,
                    widths: ['*', '*', '*', '*'],
                    body: [
                        [{ text: 'Datos del Paciente', style: 'tableHead' }, '', '', ''],
                        [{ text: 'Nombre: ', bold: true, style: 'textStyle' }, { text: data.patient.nombres + " " + data.patient.apellido1 + " " + data.patient.apellido2, style: 'textStyle' },
                        { text: 'Teléfono: ', bold: true, style: 'textStyle' }, { text: data.patient.telefono1, style: 'textStyle' }],
                        [{ text: 'Documento: ', bold: true, style: 'textStyle' }, { text: data.patient.tip_documento + " " + data.patient.num_documento, style: 'textStyle' },
                        { text: 'Nro. Celular: ', bold: true, style: 'textStyle' }, { text: data.patient.celular, style: 'textStyle' }],
                        [{ text: 'Edad - Sexo: ', bold: true, style: 'textStyle' }, { text: edad + " - " + data.patient.sexo, style: 'textStyle' },
                        { text: 'Medico: ', bold: true, style: 'textStyle' }, { text: data.professional.nombres + " " + data.professional.apellido1 + " " + data.professional.apellido2, style: 'textStyle' }
                        ],
                    ]
                },
            },
            {
                margin: [0, 20, 0, 10],
                text: 'Resultados Exámenes ', style: 'title'
            },
            {
                margin: [0, 20, 0, 10],
                text: data.results, style: 'textStyle'
            },
            {
                margin: [0, 150, 0, 10],
                text: data.notes, style: 'textStyle', alignment: 'left'
            },
        ],
        styles: {
            head: {
                fontSize: 7,
                bold: true,
                alignment: 'left'
            },
            tableheader: {
                fontSize: 11,
                bold: true,
                font: 'OpenSans'
            },
            title: {
                fontSize: 12,
                bold: true,
                alignment: 'center',
                 font: 'OpenSans'
            },
            textStyle: {
                fontSize: 8,

            },
            tableHead: {
                fontSize: 11,
                bold: true
            },
            footer: {
                fontSize: 7,
                alignment: 'center'
            },

        }
    }

    pdfMake.createPdf(documentDefinition).open();

}

export default labReport;